import { FC } from 'react';
import { useCmsPopup } from 'src/hooks/useCmsPopup';
import { CmsRelationItem } from 'src/types/cms/cmsFieldTypes';
import { CmsPopup } from 'src/types/cms/cmsWidgetTypes';

type Props = {
  popup?: CmsRelationItem<CmsPopup> | null;
};

const CmsPopupRenderer: FC<Props> = ({ popup }) => {
  useCmsPopup(popup);
  return null;
};

export default CmsPopupRenderer;
